import React from "react"
import { ApiActivity, type Activity } from "./activity.ts"

interface ActivityContext {
  activity: Activity
}

const ActivityContext = React.createContext<ActivityContext | null>(null)

export const ActivityProvider: React.FC<ActivityProvider.Props> = ({ children }) => {
  const activity = React.useMemo(() => {
    return new ApiActivity()
  }, [])

  return <ActivityContext.Provider value={{ activity }}>{children}</ActivityContext.Provider>
}

namespace ActivityProvider {
  export type Props = {
    children: React.ReactNode
  }
}

export const useActivity = () => {
  const context = React.useContext(ActivityContext)

  if (!context) {
    throw new Error("useActivity must be used within a ActivityProvider")
  }

  return context.activity
}
